"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
var Form_1 = __importDefault(require("../components/Form"));
var constants_1 = require("../data/constants");
var validateCaptcha_1 = require("./validateCaptcha");
var FormUtility = /** @class */ (function () {
    function FormUtility() {
    }
    FormUtility.getFormObject = function (formElement, formErrorMessages) {
        var _this = this;
        var inputs = formElement === null || formElement === void 0 ? void 0 : formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        var objectShape = {};
        var _loop_1 = function (i) {
            var element = inputs[i];
            var type = element.type;
            var identifier = element.dataset.formField;
            var required = element.dataset.required;
            var id = element.id;
            var strRegExp = element.dataset.regEx;
            var errorMessage = element.dataset.errorMessage;
            var min = void 0;
            var max = void 0;
            var regExp = void 0;
            var newRegExp;
            if (strRegExp) {
                regExp = strRegExp.replace(/\//g, '');
                newRegExp = new RegExp(regExp);
            }
            if (['date'].includes(type)) {
                var date = inputs[i];
                if (date.min) {
                    min = new Date(date.min);
                }
                if (date.max) {
                    max = new Date(date.max);
                }
            }
            if (required) {
                if (['text', 'textarea', 'select-one'].includes(type)) {
                    if (id.includes('zip') && newRegExp) {
                        objectShape[identifier] = yup.string()
                            .matches(newRegExp, errorMessage ? errorMessage : formErrorMessages.zip)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else if (identifier.includes('captcha')) {
                        objectShape[identifier] = yup.string()
                            .test('captcha-validation', errorMessage !== null && errorMessage !== void 0 ? errorMessage : formErrorMessages.captcha, function (value) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!value) {
                                            return [2 /*return*/, false];
                                        }
                                        return [4 /*yield*/, (0, validateCaptcha_1.isValid)(value)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); })
                            .required(errorMessage || formErrorMessages.required);
                    }
                    else {
                        objectShape[identifier] = yup.string()
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                }
                if (['tel'].includes(type)) {
                    if (newRegExp) {
                        objectShape[identifier] = yup.string()
                            .matches(newRegExp, errorMessage ? errorMessage : formErrorMessages.tel)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else {
                        objectShape[identifier] = yup.string()
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                }
                if (['date'].includes(type)) {
                    if (min && max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin)
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else if (!min && max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else if (!max && min) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin)
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                    else {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .required(errorMessage ? errorMessage : formErrorMessages.required);
                    }
                }
                if (['email'].includes(type)) {
                    objectShape[identifier] = yup.string()
                        .email(errorMessage ? errorMessage : formErrorMessages.email)
                        .required(errorMessage ? errorMessage : formErrorMessages.required);
                }
                if (['checkbox', 'radio'].includes(type)) {
                    objectShape[identifier] = yup.boolean()
                        .default(false)
                        .oneOf([true], errorMessage ? errorMessage : formErrorMessages.required)
                        .required(errorMessage ? errorMessage : formErrorMessages.required);
                }
                if (['file'].includes(type)) {
                    var fileInput = element;
                    var accept = fileInput.accept;
                    var acceptArray_1 = accept.split(',');
                    if (accept) {
                        objectShape[identifier] = yup.array()
                            .test('required', errorMessage ? errorMessage : formErrorMessages.required, function (files) {
                            return files.length > 0;
                        })
                            .test('fileType', errorMessage ? errorMessage : formErrorMessages.fileType, function (files) {
                            var valid = true;
                            files === null || files === void 0 ? void 0 : files.forEach(function (file) {
                                var fileType = file.type;
                                if (!fileType) {
                                    fileType = 'image/' + file.name.split('.').pop().toLowerCase();
                                }
                                if (!acceptArray_1.includes(fileType))
                                    valid = false;
                            });
                            return valid;
                        })
                            .test('fileSize', errorMessage ? errorMessage : formErrorMessages.fileSize, function (files) {
                            var valid = true;
                            files === null || files === void 0 ? void 0 : files.forEach(function (file) {
                                var size = file.size / 1024 / 1024;
                                if (size > 5)
                                    valid = false;
                            });
                            return valid;
                        });
                    }
                    else {
                        objectShape[identifier] = yup.array()
                            .test('required', errorMessage ? errorMessage : formErrorMessages.required, function (files) {
                            return files.length > 0;
                        })
                            .test('fileSize', errorMessage ? errorMessage : formErrorMessages.fileSize, function (files) {
                            var valid = true;
                            files === null || files === void 0 ? void 0 : files.forEach(function (file) {
                                var size = file.size / 1024 / 1024;
                                if (size > 5)
                                    valid = false;
                            });
                            return valid;
                        });
                    }
                }
            }
            else {
                if (['text', 'textarea', 'select-one'].includes(type)) {
                    if (id.includes('zip') && newRegExp) {
                        objectShape[identifier] = yup.string()
                            .test('is-empty', function () { return errorMessage ? errorMessage : formErrorMessages.zip; }, function (value) { return !!(value === '' || (value === null || value === void 0 ? void 0 : value.match(newRegExp))); });
                    }
                    else {
                        objectShape[identifier] = yup.string();
                    }
                }
                if (['tel'].includes(type)) {
                    if (newRegExp && element.value !== '') {
                        objectShape[identifier] = yup.string()
                            .test('is-empty', function () { return errorMessage ? errorMessage : formErrorMessages.tel; }, function (value) { return !!(value === '' || (value === null || value === void 0 ? void 0 : value.match(newRegExp))); });
                    }
                    else {
                        objectShape[identifier] = yup.string();
                    }
                }
                if (['date'].includes(type)) {
                    if (min && max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin)
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax);
                    }
                    else if (!min && max) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .max(max, errorMessage ? errorMessage : formErrorMessages.dateMax);
                    }
                    else if (!max && min) {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; })
                            .min(min, errorMessage ? errorMessage : formErrorMessages.dateMin);
                    }
                    else {
                        objectShape[identifier] = yup.date()
                            .nullable()
                            .transform(function (curr, orig) { return orig === '' ? null : curr; });
                    }
                }
                if (['email'].includes(type)) {
                    objectShape[identifier] = yup.string()
                        .email(errorMessage ? errorMessage : formErrorMessages.email);
                }
                if (['checkbox', 'radio'].includes(type)) {
                    objectShape[identifier] = yup.boolean()
                        .default(false);
                }
                if (['file'].includes(type)) {
                    var fileInput = element;
                    var accept = fileInput.accept;
                    var acceptArray_2 = accept.split(',');
                    if (accept) {
                        objectShape[identifier] = yup.array()
                            .test('fileType', errorMessage ? errorMessage : formErrorMessages.fileType, function (files) {
                            var valid = true;
                            files === null || files === void 0 ? void 0 : files.forEach(function (file) {
                                var fileType = file.type;
                                if (!fileType) {
                                    fileType = 'image/' + file.name.split('.').pop().toLowerCase();
                                }
                                if (!acceptArray_2.includes(fileType))
                                    valid = false;
                            });
                            return valid;
                        })
                            .test('fileSize', errorMessage ? errorMessage : formErrorMessages.fileSize, function (files) {
                            var valid = true;
                            files === null || files === void 0 ? void 0 : files.forEach(function (file) {
                                var size = file.size / 1024 / 1024;
                                if (size > 5)
                                    valid = false;
                            });
                            return valid;
                        });
                    }
                }
            }
        };
        for (var i = 0; i < inputs.length; i++) {
            _loop_1(i);
        }
        return yup.object().shape(objectShape);
    };
    FormUtility.getFormValues = function (formElement) {
        var inputs = formElement === null || formElement === void 0 ? void 0 : formElement.querySelectorAll("[".concat(constants_1.DATA_FORM_FIELD, "]"));
        var formValues = {};
        for (var i = 0; i < inputs.length; i++) {
            var element = inputs[i];
            var type = element.type;
            var identifier = element.dataset.formField;
            if (['text', 'textarea', 'email', 'tel', 'date', 'select-one'].includes(type)) {
                formValues[identifier] = Form_1.default.getValue(formElement, identifier);
            }
            if (['checkbox', 'radio'].includes(type)) {
                formValues[identifier] = Form_1.default.getChecked(formElement, identifier);
            }
            if (['file'].includes(type)) {
                formValues[identifier] = Form_1.default.getFiles(formElement, identifier);
            }
        }
        return formValues;
    };
    return FormUtility;
}());
exports.default = FormUtility;
